import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { ClipboardList } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function ITCompaniesTicketsPage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Tickets"
      description="Gerencie tickets de suporte dos seus clientes."
      icon={ClipboardList}
    />
  
    </MainLayout>);
}

